export const validateUrl = (url?: string, message?: string) => {
  const errorMessage = message || 'Issuer URL needs to be a valid URL';
  if (!url?.length) {
    return true;
  }
  try {
    const urlObject = new URL(url);
    if (urlObject.protocol !== 'https:') {
      return errorMessage;
    }
    return true;
  } catch (e) {
    return errorMessage;
  }
};
